// @flow
// The only channel to MissingChargesNotice: dispatch through
// notifyMissingTransactionTypes, never by this string.
export const MISSING_TRANSACTION_TYPES_EVENT =
  'fortress:missing-transaction-types';

export function notifyMissingTransactionTypes(types: ?Array<?string>): void {
  const reported = types?.filter(Boolean);
  if (!reported?.length) return;
  window.dispatchEvent(
    new CustomEvent(MISSING_TRANSACTION_TYPES_EVENT, { detail: reported }),
  );
}
